/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerGeneratedDocumentType } from './ScreenerGeneratedDocumentType';
import {
    ScreenerGeneratedDocumentTypeFromJSON,
    ScreenerGeneratedDocumentTypeFromJSONTyped,
    ScreenerGeneratedDocumentTypeToJSON,
} from './ScreenerGeneratedDocumentType';

/**
 * 
 * @export
 * @interface UploadExternalEhrDocumentsRequest
 */
export interface UploadExternalEhrDocumentsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    push_insurance_eligibility_check_results?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    push_clinic_package?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    push_full_clinic_package?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    clinic_package_document_ids?: Array<string>;
    /**
     * 
     * @type {Array<ScreenerGeneratedDocumentType>}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    push_generated_document_types?: Array<ScreenerGeneratedDocumentType>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadExternalEhrDocumentsRequest
     */
    push_additional_document_ids?: Array<string>;
}

/**
 * Check if a given object implements the UploadExternalEhrDocumentsRequest interface.
 */
export function instanceOfUploadExternalEhrDocumentsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UploadExternalEhrDocumentsRequestFromJSON(json: any): UploadExternalEhrDocumentsRequest {
    return UploadExternalEhrDocumentsRequestFromJSONTyped(json, false);
}

export function UploadExternalEhrDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadExternalEhrDocumentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'push_insurance_eligibility_check_results': !exists(json, 'push_insurance_eligibility_check_results') ? undefined : json['push_insurance_eligibility_check_results'],
        'push_clinic_package': !exists(json, 'push_clinic_package') ? undefined : json['push_clinic_package'],
        'push_full_clinic_package': !exists(json, 'push_full_clinic_package') ? undefined : json['push_full_clinic_package'],
        'clinic_package_document_ids': !exists(json, 'clinic_package_document_ids') ? undefined : json['clinic_package_document_ids'],
        'push_generated_document_types': !exists(json, 'push_generated_document_types') ? undefined : ((json['push_generated_document_types'] as Array<any>).map(ScreenerGeneratedDocumentTypeFromJSON)),
        'push_additional_document_ids': !exists(json, 'push_additional_document_ids') ? undefined : json['push_additional_document_ids'],
    };
}

export function UploadExternalEhrDocumentsRequestToJSON(value?: UploadExternalEhrDocumentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'push_insurance_eligibility_check_results': value.push_insurance_eligibility_check_results,
        'push_clinic_package': value.push_clinic_package,
        'push_full_clinic_package': value.push_full_clinic_package,
        'clinic_package_document_ids': value.clinic_package_document_ids,
        'push_generated_document_types': value.push_generated_document_types === undefined ? undefined : ((value.push_generated_document_types as Array<any>).map(ScreenerGeneratedDocumentTypeToJSON)),
        'push_additional_document_ids': value.push_additional_document_ids,
    };
}

